'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  UNITED_STATES: 'United States of America',
  // TODO: Remove prefixes from states
  US_GULF_COAST_AL: 'US - Alabama',
  US_AK: 'US - Alaska',
  US_AZ: 'US - Arizona',
  US_MID_CONTINENT_AR: 'US - Arkansas',
  US_ROCKIES_CA: 'US - California',
  US_CO: 'US - Colorado',
  US_CT: 'US - Connecticut',
  US_DE: 'US - Delaware',
  US_DC: 'US - District of Columbia',
  US_FL: 'US - Florida',
  US_GA: 'US - Georgia',
  US_HI: 'US - Hawaii',
  US_ID: 'US - Idaho',
  US_IL: 'US - Illinois',
  US_IN: 'US - Indiana',
  US_IA: 'US - Iowa',
  US_MID_CONTINENT_KS: 'US - Kansas',
  US_KY: 'US - Kentucky',
  US_GULF_COAST_LA: 'US - Louisiana',
  US_ME: 'US - Maine',
  US_MD: 'US - Maryland',
  US_MA: 'US - Massachusetts',
  US_MI: 'US - Michigan',
  US_MN: 'US - Minnesota',
  US_GULF_COAST_MS: 'US - Mississippi',
  US_MO: 'US - Missouri',
  US_MT: 'US - Montana',
  US_NE: 'US - Nebraska',
  US_NV: 'US - Nevada',
  US_NH: 'US - New Hampshire',
  US_NJ: 'US - New Jersey',
  US_ROCKIES_NM: 'US - New Mexico',
  US_NY: 'US - New York',
  US_NC: 'US - North Carolina',
  US_ND: 'US - North Dakota',
  US_APPALACHIA_OH: 'US - Ohio',
  US_MID_CONTINENT_OK: 'US - Oklahoma',
  US_OR: 'US - Oregon',
  US_APPALACHIA_PA: 'US - Pennsylvania',
  US_RI: 'US - Rhode Island',
  US_SC: 'US - South Carolina',
  US_SD: 'US - South Dakota',
  US_TN: 'US - Tennessee',
  US_TX: 'US - Texas',
  US_UT: 'US - Utah',
  US_VT: 'US - Vermont',
  US_VA: 'US - Virginia',
  US_WA: 'US - Washington',
  US_APPALACHIA_WV: 'US - West Virginia',
  US_WI: 'US - Wisconsin',
  US_ROCKIES_WY: 'US - Wyoming',
  NORTH_AMERICA: 'North America',
  // TODO: Remove prefixes from international areas
  INTL_EUROPE: 'Europe',
  SOUTH_AMERICA: 'South America',
  INTL_AFRICA: 'Africa',
  INTL_ASIA: 'Asia',
  INTL_CANADA: 'Canada',
  INTL_LATIN_AMERICA: 'Latin America',
  INTL_MIDDLE_EAST: 'Middle East',
  INTERNATIONAL: 'International',
  ONSHORE: 'Onshore',
  OFFSHORE: 'Offshore'
});